import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Box, Typography, TextField, Grid, Button } from '@material-ui/core'
import { useStyles } from './style'
import { AppButton, Breadcrumb, DisplayMessage, Loader } from '../../Components'
import { TableOutline, Cards, OutlinedButton } from '../../elements'
import { useParams } from 'react-router-dom'
import { ALL, applicationStatus, getSystemsPendingHeadings, steps, SYSTEMADDITION } from './constant'
import { programService } from '../../Services'
import _ from 'lodash'
import * as yup from 'yup'
import * as messageTypes from '../../utils/messageTypes'
import { Form, Formik } from 'formik'
import UploadProgramFileLogo from '../../elements/icons/uploadProgramFileLogo'
import StatusButton from '../../Components/StatusButton'
import downloadIcon from '../../Assets/Images/download.svg'
import Process from './Process'
import moment from 'moment'
import Error404 from '../ErrorPages/Error404'

const validationSchema = yup.object({
  siteId: yup
    .string('Enter site id')
    .required('Site Id is required'),
  customerName: yup
    .string('Enter customer name')
    .required('Customer name is required'),
  address: yup
    .string('Enter installation address')
    .required('Installation address is required'),
})
const filterStatus = {
  'All': '',
  'Verification Pending': 'Site_Submitted',
  'Verification Successful': 'Site_Approved',
  'Verification Failed': 'Site_Rejected'
}
function SystemAddition(props) {
  const classes = useStyles()
  const { programId } = useParams()
  const [program, setProgram] = useState({})
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState()
  const [loading, setLoading] = useState(false)
  const [headingStatus, setHeadingStatus] = useState(ALL)
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [totalCount, setTotalCount] = useState(1)
  const [tableData, setTableData] = useState([])
  const [processOpen, setProcessOpen] = useState(false)
  const { currentUser } = useSelector(state => state.auth)

  const handleDropdownChange = (value) => {
    setPage(1)
    setHeadingStatus(value)
  }

  const handlePageChange = (newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    setPage(1)
  }

  const getProgram = () => {
    programService.getProgramsById(currentUser.account_id, programId)
      .then(programData => {
        setProgram(programData)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getSystems = () => {
    setLoading(true)
    const filter = filterStatus[headingStatus]
    programService.getSystems(currentUser.account_id, programId, page - 1, rowsPerPage, filter)
      .then(systemsPendingData => {
        setSystemsTable(systemsPendingData.applications)
        setTotalCount(systemsPendingData.total_count)
        setLoading(false)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
        setLoading(false)
      })
  }

  const setSystemsTable = (systemsData) => {
    let systemTable = []
    systemsData.map(obj => {
      let tableObj = [
        {
          id: 'siteId',
          className: classes.sidInTable,
          value: <Box className={classes.link} onClick={() => props.history.push(`/programs/${programId}/systems-addition/view-application/${obj.application_id}`)}>{_.get(obj, 'site_id', '')}</Box>,
        },
        {
          id: 'optionalId',
          className: classes.oidInTable,
          value: _.get(obj, 'homeowner_info.premise_id', '-'),
        },
        {
          id: 'applicationForm',
          className: classes.idInTable,
          value: <Box ml={6}>{_.get(obj, 'signed_application_form_downloadable_url') ? <a href={obj.signed_application_form_downloadable_url} target="_blank"><img src={downloadIcon} alt="" /></a> : 'NA'}</Box>,
        },
        {
          id: 'homeOwnerFullName',
          className: classes.nameInTable,
          value: `${_.get(obj, 'homeowner_info.first_name', '-')} ${_.get(obj, 'homeowner_info.last_name', '')}`,
        },
        {
          id: 'applicationStatus',
          className: classes.statusInTable,
          value: _.get(obj, 'application_status', '') && <StatusButton color={applicationStatus[obj.application_status][1]} text={applicationStatus[obj.application_status][0]} />,
        },
      ]
      systemTable.push(tableObj)
    })
    setTableData(systemTable)
  }

  const renderSystemAdditionTable = () => (
    <>
      <TableOutline
        tableHeadings={getSystemsPendingHeadings(headingStatus, SYSTEMADDITION, classes)}
        tableData={tableData}
        totalElement={totalCount}
        loading={loading}
        pagination={true}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handlePageChange}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleDropdownChange={handleDropdownChange}
        selectedStatus={headingStatus}
      />
    </>
  )

  useEffect(() => {
    getProgram()
  }, [])

  useEffect(() => {
    getSystems()
  }, [page, rowsPerPage, headingStatus])

  const getBreadcrumbs = () => {
    let value = [{ 'Home': '/' }, { 'Programs': '/programs' }]
    if (program) {
      value.push({ [program?.program_name_admin_ui]: `/programs/${program.id}` })
      value.push({ 'Systems Addition': `/programs/${program.id}/systems-addition` })
    } else {
      value.push({ 'Systems Addition': '' })
    }
    return value
  }

  if (program && program.feature_flags && program.feature_flags.system_enrollment_option !== 'SYSTEM_ADDITION') {
    return (<Error404 />)
  }

  return (
    <Box>
      <Loader loading={loading} />
      <Breadcrumb value={getBreadcrumbs()} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      {processOpen && <Process open={processOpen} handleClose={() => setProcessOpen(false)} />}
      <Box className={classes.headerWrapper} display="flex" flexWrap="wrap" justifyContent='space-between' alignItems="center">
        <Box>
          <Typography className={classes.title}>Systems Tracker</Typography>
        </Box>
        <Box className={classes.buttonContainer}>
          <AppButton className={`${classes.buttons} ${classes.mr4}`} text="Add a new system" fill={false} onClick={() => props.history.push(`/programs/${programId}/systems-addition/application-form`)} />
          <AppButton className={classes.buttons} text="See how adding a new system works" fill={false} onClick={() => setProcessOpen(true)} />
        </Box>
      </Box>
      <Cards className={classes.cardWrapper} children={renderSystemAdditionTable()} />
      <Box className={classes.bottomText}>
        All approved applications can be located in “Systems Enrolled” section
      </Box>
    </Box >
  )
}

export default SystemAddition